import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
// Import our authentication service
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
/* import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map'; */
import { Person, RoleType } from '../../models/index';
import { map, first } from 'rxjs/operators';
import { TranslationService } from './translation.service';

@Injectable()
export class AuthGuard implements CanActivate {
  homePath = '';

  constructor(private auth: AuthService, private router: Router,
    private langService: TranslationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.auth.getUserData().pipe(
      map(user => {
        return this.routeValidation(user as Person, state)
      })
    ).pipe(first());
  }

  /*   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
      return this.auth.getUserData().map(user => {
        return this.routeValidation(user, state)
      }).first();
    } */

  routeValidation = (user: Person, state: RouterStateSnapshot): boolean => {
    const lang = this.langService.getCurrentLang();
    this.homePath = `/${lang}`;

    if (user) {
      switch (user.role) {

        case RoleType.Auditor:
          if (state.url.indexOf(`${this.homePath}/auditor`) == -1)
            this.router.navigate([`${this.homePath}/auditor`]);
          return true;

        case RoleType.Technician:
          if (state.url.indexOf(`${this.homePath}/techincian`) == -1)
            this.router.navigate([`${this.homePath}/techincian`]);
          return true;

        case RoleType.Clinic:
        case RoleType.Doctor:
          if (state.url.indexOf(`${this.homePath}/clinic`) == -1)
            this.router.navigate([`${this.homePath}/clinic`]);
          return true;

        case RoleType.SuperAdmin:
        case RoleType.Admin:
          if (state.url.indexOf(`${this.homePath}/administrator`) == -1)
            this.router.navigate([`${this.homePath}/administrator`]);
          return true;

        case RoleType.TaskMaster:
          if (state.url.indexOf(`${this.homePath}/taskmaster`) == -1)
            this.router.navigate([`${this.homePath}/taskmaster`]);
          return true;

        default:
          {
            if (state.url != this.homePath) {
              this.router.navigate([this.homePath]);
              return false;
            }
            else
              return true;
          }
      }
    } else {
      if (state.url != this.homePath) {
        this.router.navigate([this.homePath]);
        return false;
      }
      else
        return true;
    }
  }
}
